// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"104b9756","864":"104b9756"}[chunkId] + ".chunk.css";
};